import mlClient from './client';
const opts = {
    headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
    },
};
const apiType = 'ml';
export const imgProcessingPostApi = async (body, url, isNotHost, logger) => {
    logger ? mlClient.setLogger(logger) : undefined;
    return mlClient.post(url, apiType, { data: body, ...opts }, isNotHost);
};
